import { useDriverManagement } from '@/api/useDriverManagement'
import type { components } from '@/types/api/v1'
import { useScheduleItems } from '../Context/ScheduleItems/ScheduleItemsContext'
import { ScheduleItemsContextProvider } from '../Context/ScheduleItems/ScheduleItemsContextProvider'
import { ScheduleGrid } from '../Grid/ScheduleGrid'
import { DayCellRenderer } from './DayCell/DayCellRenderer'
import { DriverInfoCellRenderer } from './DriverInfoCellRenderer'
import { EquipmentScheduleModal } from './EquipmentScheduleModal'

type RowType = components['schemas']['DriverInfoRow']

export function DriverScheduleGrid() {
  const { useDriverOverview } = useDriverManagement()
  const { data, isLoading } = useDriverOverview({ onlyActiveDrivers: true, includeCarriers: true })

  return (
    <ScheduleItemsContextProvider rows={data} isLoading={isLoading}>
      <EquipmentScheduleModal />
      <InnerDriverScheduleGrid />
    </ScheduleItemsContextProvider>
  )
}

function InnerDriverScheduleGrid() {
  const { rows, isLoading } = useScheduleItems<RowType>()
  return (
    <ScheduleGrid
      infoCell={DriverInfoCellRenderer}
      dayCell={DayCellRenderer}
      rows={rows}
      primaryKey='driver'
      isLoading={isLoading}
    />
  )
}
